export default __webpack_public_path__ + "static/dashboard-pattern-af70cb71414713dd3d351dbb560206bc.png";